import Link                                                      from "next/link";
import { Users, Trophy, Star, Skull }                            from "lucide-react";
import Avatar                                                    from "@/components/Avatar";
import { formatar_numero, link_da_crew }                         from "@/utils/RpgFunction";

/* Cartao da crew (home e /crews). A barra compara o XP da crew com o da
   crew que mais tem XP (maiorXp), entao so a primeira fica cheia. */
export default function CrewCard({ crew, maiorXp }) {
  if (!crew) return null;

  const rank        = crew.posicao;
  const podio       = typeof rank === "number" && rank <= 3;
  const xpTotal     = Number(crew.xpTotal) || 0;
  const referencia  = Math.max(Number(maiorXp) || 0, xpTotal);
  const largura     = referencia > 0 ? Math.round((xpTotal / referencia) * 100) : 0;
  const membros     = crew.membros?.length || 0;

  return (
    <Link
      href={link_da_crew(crew) || "/crews"}
      className={`void-card-hover block p-5 ${(rank === 1) ? "void-glow-intense border-primary" : ""}`}
    >
      <div className="flex items-start gap-4">
        {/* Logo */}
        <div className="relative flex-shrink-0">
          <div className={`w-16 h-16 rounded-xl overflow-hidden border-2 ${
            rank === 1 ? "border-cosmic-gold void-glow" : "border-border"
          }`}>
            <Avatar
              src={crew.imagem}
              alt={crew.nome}
              className="w-full h-full object-cover"
            />
          </div>
          {podio && (
            <div className="absolute -top-2 -right-2">
              <div className={`w-7 h-7 rounded-full flex items-center justify-center font-orbitron text-xs font-bold ${
                rank === 1 ? "bg-cosmic-gold text-black" :
                rank === 2 ? "bg-gray-400 text-black" :
                "bg-amber-600 text-white"
              }`}>
                {rank}
              </div>
            </div>
          )}
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-orbitron font-bold text-foreground truncate">
              {crew.nome}
            </h3> {(rank === 1) && <Star className="w-4 h-4 text-cosmic-gold fill-cosmic-gold" />}
          </div>

          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-2 text-sm text-muted-foreground">
            <span className="flex items-center gap-1">
              <Users className="w-4 h-4" />
              {membros} {membros === 1 ? "membro" : "membros"}
            </span>
            <span className="flex items-center gap-1">
              <Skull className="w-4 h-4 text-primary" />
              {formatar_numero(crew.vitoriasPvp)} vitórias PvP
            </span>
          </div>
        </div>
      </div>

      {/* XP da crew */}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex justify-between text-xs text-muted-foreground">
          <span className="flex items-center gap-1"><Trophy className="w-3 h-3 text-primary" /> XP da crew</span>
          <span className="text-primary font-semibold">{formatar_numero(xpTotal)} XP</span>
        </div>
        <div className="mt-2 h-1.5 bg-secondary rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-void rounded-full transition-all duration-500"
            style={{ width: `${largura}%` }}
          />
        </div>
      </div>
    </Link>
  );
}
